import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Logo } from './store/logo.model';

@Injectable({
    providedIn: 'root'
})
export class LogoService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private logoUri = `${environment.apiLocation}/Upload`;

    public getLogo(UploadType): Observable<Array<Logo>> {
        this.log.verbose({
            type: 'LogoService:getLogo',
            uri: this.logoUri
        });
        return this.http
            .post<Array<Logo>>(this.logoUri, { Uploadtype: UploadType })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'LogoService:reponse',
                        res
                    })
                )
            );
    }

    public putLogo(logo: Logo): Observable<IGenericResponse<Logo>> {
        return this.http
            .put<IGenericResponse<Logo>>(this.logoUri, { UploadList: [logo] })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'LogoService:putLogo',
                        data
                    })
                )
            );
    }
}
